module.exports = __webpack_public_path__ + "03bed08df0ee2e37b42f3070d79ee456.svg";